<span
  >{{ 'email_preferences.slidedown.text' | transloco }}
  <a href="/" class="link">{{
    'email_preferences.slidedown.link' | transloco
  }}</a>
</span>
